import { render, staticRenderFns } from "./DatasetGroupSelector.vue?vue&type=template&id=32189ae9&scoped=true"
import script from "./DatasetGroupSelector.vue?vue&type=script&lang=js"
export * from "./DatasetGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./DatasetGroupSelector.vue?vue&type=style&index=0&id=32189ae9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32189ae9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32189ae9')) {
      api.createRecord('32189ae9', component.options)
    } else {
      api.reload('32189ae9', component.options)
    }
    module.hot.accept("./DatasetGroupSelector.vue?vue&type=template&id=32189ae9&scoped=true", function () {
      api.rerender('32189ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetGroupSelector.vue"
export default component.exports